module.exports = __webpack_public_path__ + "static/media/userProfileIcon.aba02adc.svg";